<template>
  <div>
    <b-row class="pb-3">
      <b-col cols="7">
        <h4 class="mb-4">{{ title }}</h4></b-col
      >

      <b-col cols="12" class="locked-customer-lg mb-3">
        <LockedCustomer />
      </b-col>
    </b-row>

    <b-row>
      <b-col cols="12" class="mt-5">
        <div>
          <h4 class="table-controls-bg p-3 mb-0">Records</h4>
        </div>
        <table-view
          ref="laeTableView"
          v-model="getUnassignedLicenses"
          :columnTitles="columnTitles"
          :validationData="validationData"
          :submitEditedRows="true"
          :isEditable="false"
          :editableColumns="editableColumns"
          :options="tabulatorOptions"
          :showLoader="showLoader"
          @submit="onSubmit"
        >
        </table-view>

        <table-results
          :results="leaResults"
          :tableFields="leaResultsTableFields"
        >
        </table-results>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

import LockedCustomer from "@/vue/components/LockedCustomer.vue";
import TableView from "@/vue/components/tabulator/Index.vue";
import TableResults from "@/vue/components/TableResults.vue";

import { notify, DURATION, TYPE } from "@8x8/oxygen-toaster";

export default {
  name: "lae",
  props: ["title"],
  components: {
    LockedCustomer,
    TableView,
    TableResults,
  },
  data() {
    return {
      labelTheme: { fontWeight: 600 },
      iconTheme: { color: "#0376DA", size: "18px" },
      showLoader: false,
      tabulatorOptions: {
        pagination: "local", //enable local pagination.
        paginationSize: 50, // this option can take any positive integer value
        paginationSizeSelector: [10, 50, 100, 150, 200, 500],
      },
      editableColumns: ["newAddress"],
      columnTitles: {
        isSuspended: "Is Suspended",
        licenseId: "License Id",
        skuDesc: "SKU Description",
        name: "License Pool Name",
        status: "Status",
        phoneNumber: "Phone Number",
        serviceOwner: "Service Owner",
        referenceId: "Reference Id",
        licensePoolId: "License Pool Id",
        serviceAddress: "Current Address",
        newAddress: "New Address",
        suspendReason: "Suspend Reason",
      },
      leaResultsTableFields: [
        { key: "success", class: "text-center align-middle" },
        { key: "licenseId", label: "License Id", class: "w-auto align-middle" },
        {
          key: "skuDesc",
          label: "SKU Description",
          class: "w-auto align-middle",
        },
        {
          key: "name",
          label: "License Pool Name",
          class: "w-auto align-middle",
        },
        {
          key: "serviceAddress",
          label: "Current Address",
          class: "w-auto align-middle",
        },
        {
          key: "newAddress",
          label: "New Address",
          class: "w-auto align-middle",
        },
      ],
      submittedData: [],
    };
  },
  computed: {
    ...mapGetters([
      "getCustomer",
      "getUnassignedLicenses",
      "getSiteAddresses",
      "getLeaUpdateResults",
    ]),
    validationData() {
      return {
        newAddress: [
          {
            type: "in",
            parameters: this._.map(this.getSiteAddresses, "freeForm").join("|"),
          },
        ],
      };
    },
    leaResults() {
      let results = { success: [], error: [], message: "", successRate: "" };
      if (this.getLeaUpdateResults) {
        results.success = this._.values(
          this._.merge(
            this._.keyBy(this.submittedData, "licenseId"),
            this._.keyBy(this.getLeaUpdateResults, "licenseId")
          )
        );
      }
      return results;
    },
  },
  methods: {
    ...mapActions([
      "fetchUnassignedLicenses",
      "fetchSiteAddresses",
      "updateSiteAddress",
    ]),
    showModal() {
      this.$root.$emit("bv::show::modal", "modal-customer-lock");
    },
    onSubmit(data) {
      console.log("onSubmit data");
      console.log(data);
      this.submittedData = data;
      //find
      let body = this._.map(data, (item, key) => {
        return {
          licenseId: item.licenseId,
          serviceAddress: this._.find(
            this.getSiteAddresses,
            function (address) {
              return address.freeForm.includes(item.newAddress);
            }
          ),
        };
      });

      console.log("body");
      console.log(body);
      this.showLoader = true;
      this.updateSiteAddress({
        data: body,
        success: (response) => {
          this.showLoader = false;

          console.log("got updateSiteAddress");
          notify({ content: "Updated addresses", duration: 3000 });
          this.retrieveUnassignedLicenses();
        },
        error: (response) => {
          console.log("got error updateSiteAddress");
          console.log(response);
          this.showLoader = false;
          notify({
            content: response,
            type: TYPE.error,
            duration: DURATION.INFINITE,
          });
        },
      });
    },
    retrieveUnassignedLicenses() {
      this.showLoader = true;
      this.fetchUnassignedLicenses({
        success: (response) => {
          console.log("got fetchUnassignedLicenses");
          console.log(response);
          notify({ content: response, duration: 3000 });
          this.setFilter();
          this.showLoader = false;
        },
        error: (response) => {
          console.log("got error fetchUnassignedLicenses");
          console.log(response);
          this.showLoader = false;
        },
      });
    },
    retrieveSiteAddresses() {
      this.fetchSiteAddresses({
        success: (response) => {
          console.log("got fetchSiteAddresses");
          console.log(response);
        },
        error: (response) => {
          console.log("got error fetchSiteAddresses");
          console.log(response);
        },
      });
    },
    setFilter() {
      this.$refs.laeTableView.filtersList = [
        {
          filterField: {
            label: "Status",
            value: "status",
          },
          filterType: {
            label: "equals",
            value: "=",
          },
          filterValue: "PENDING_CONFIGURATION",
          isColumnDataPredifined: false,
          predefinedColumnValues: [],
        },
      ];
      this.$refs.laeTableView.updateFilter();

      if (
        !document.querySelector("#collapse-filter").classList.contains("show")
      ) {
        this.$root.$emit("bv::toggle::collapse", "collapse-filter");
      }
    },
  },
  mounted() {
    if (!this.getCustomer.customerName) {
      this.showModal();
    } else {
      this.retrieveUnassignedLicenses();
      this.retrieveSiteAddresses();
    }

    EventBus.$on("lock-customer", (event) => {
      console.log("lock-customer on ELA");
      this.retrieveUnassignedLicenses();
      this.retrieveSiteAddresses();
    });
  },
  beforeDestroy() {
    console.log("beforeDestroy CSR");
    EventBus.$off("lock-customer");
  },
};
</script>
